// 新品收集提示
<template>
  <transition name="van-slide-up">
    <div class="tips-box" v-show="showTips">
      <!-- close-icon -->
      <div class="close-icon-content">
        <van-icon
          name="close"
          class="close-icon"
          size="22px"
          @click.stop="toggleShow"
        />
      </div>

      <div class="tips-content">
        <div class="tips-container">
          <div class="text">
            <div class="title">没找到想要的商品？</div>
            <div class="tips">
              没有找到相关的宝贝请提交您想要的商品，
              如平台上架商品后，将第一时间通知您。
            </div>
          </div>
          <!-- btn -->
          <div class="to-add" @click.stop="toNewGoodsCollectPage">去提交</div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'AddNewGoodsCollectTipsVue',
  mixins: [],
  components: {},
  // 数据部分
  props: {},
  data() {
    return {
      showTips: false,
    }
  },
  computed: {},
  watch: {},
  // 生命周期
  created() {},
  mounted() {},
  unmounted() {},
  // 方法
  methods: {
    toggleShow() {
      this.showTips = !this.showTips
    },
    toNewGoodsCollectPage() {
      const toUrl = this.$router.resolve('/NewGoodsCollect')
      window.open(toUrl.href, '_blank')
    },
  },
}
</script>
<style lang="less" scoped>
.tips-box {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  text-align: left;
  box-sizing: border-box;
  z-index: 99999;
  .tips-content {
    box-sizing: border-box;
    background: url('../assets/new-collect-bg.png') center no-repeat;
    background-size: cover;
    width: 100vw;
    height: 200px;
    box-shadow: 0px 4px 12px 0px rgba(184, 184, 184, 0.5);
    background-position-x: -1400px;
    .tips-container {
      width: 1200px;
      margin: 0 auto;
      border-radius: 8px;
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .text {
      .title {
        font-size: 18px;
        color: #0f6eea;
        padding-bottom: 16px;
        font-weight: bold;
      }
      .tips {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #41485d;
        line-height: 28px;
      }
    }
    .to-add {
      width: 320px;
      height: 80px;
      background: #0f6eea;
      border-radius: 4px;
      line-height: 80px;
      text-align: center;
      color: #fff;
      flex: 0 0 320px;
      font-size: 16px;
      cursor: pointer;
    }
  }
  .close-icon-content {
    text-align: right;
    padding-right: 20px;
  }
  .close-icon {
    position: relative;
    font-size: 30px;
    top: 40px;
    cursor: pointer;
  }
}

</style>
